import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Userlist = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`https://c-greenproject.org:8000/users/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setUsers(response.data);
  };

  const deleteUser = async (userId) => {
    const token = localStorage.getItem("token");

    await axios.delete(`https://c-greenproject.org:8000/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    getUsers();
  };

  return (
    <div>
      <h2 className="title">
        <strong>List of Users</strong>
      </h2>
      <Link to="/users/add" type="button" class="btn btn-primary mb-2">
        Add New
      </Link>
      <table className="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Kode Blokchain</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.uuid}>
              <td>{index + 1}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>{user.uuid}</td>
              <td className="text-center">
                <Link
                  to={`/users/edit/${user.uuid}`}
                  type="button"
                  class="btn btn-info button-tabel"
                >
                  Edit
                </Link>
                <button
                  onClick={() => deleteUser(user.uuid)}
                  type="button"
                  class="btn btn-danger button-tabel ms-2"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Userlist;
